import {createRouter, createWebHistory} from "vue-router";
import {Permissions} from "./infrastructure/permissions";
import * as views from './views';
import {currentUser} from "@/infrastructure/user";


const routes = [
    // HPO views
    {
        name: 'hpo:list',
        path: '/list',
        component: views.HpoListView,
        meta: {
            requiresAuth: true,
            requiresPermission: Permissions.HPO__LIST_ACCESS,
        },
    },
    {
        name: 'hpo:dashboard',
        path: '/dashboard/:id(\\d+)',
        component: views.HpoDashboardView,
    },
    {
        name: 'hpo:sign-in',
        path: '/sign_in/form',
        component: views.HpoPinLoginView,
    },
    {
        name: 'hpo:member-not-active',
        path: '/member_not_active',
        component: views.HpoMemberNotActiveView,
    },

    // Device views
    {
        name: 'device:login',
        path: '/device/login',
        component: views.DeviceLoginView,
    },
    {
        name: 'device:login-bookmark',
        path: '/device/login-bookmark',
        component: views.DeviceLoginBookmarkView,
    },
    {
        name: 'device:auth-complete',
        path: '/device/auth/complete',
        component: views.DeviceAuthenticationCompleteView,
    },
    {
        name: 'device:manage',
        path: '/device/manage',
        component: views.DeviceManageView,
        meta: {
            requiresAuth: true,
            requiresPermission: Permissions.DEVICE__MANAGE,
        },
    },

    // Error views
    {
        name: 'error:permission-denied',
        component: views.PermissionDeniedView,
    },
    {
        name: 'error:not-found',
        path: '/:pathMatch(.*)*',
        component: views.NotFoundView,
    },
];

export const router = createRouter({
    routes,
    history: createWebHistory(),
});

router.beforeEach((to, from) => {
    if (to.meta.requiresAuth && !currentUser.isAuthenticated) {
        window.location = reverseUrl('web:account:login');
        return false;
    }

    if (to.meta.requiresPermission && !currentUser.hasPermission(to.meta.requiresPermission)) {
        return {
            name: 'error:permission-denied',
        };
    }

    return true;
});
